import { ERROR_HEADER, LOADING_MESSAGE_E, TOASTR_ERROR_OPTIONS, showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
export default class Err {
  static get(code, message) {
    return {
      code,
      message
    };
  }
  static handle(error, context, message = "") {
    if (error.statusText === "abort") return;
    if (context && !context.redirect) {
      context.redirect = path => location.hash = path;
    }
    switch (error.code) {
      case "NotAuthorizedException":
        {
          const path = encodeURIComponent(window.location.hash);
          window.location = `#/login?state=${path}`;
          break;
        }
      case "UnverifiedError":
        window.location = "#/unverified";
        break;
      case "TrialEndedError":
        window.location = "#/trial-ended";
        break;
      default:
        {
          var _error$responseJSON;
          Amplitude.logHandledError(error, context);
          /* eslint-disable no-console */
          console.error(error);
          /* eslint-enable no-console */
          showToast("error", message || ((_error$responseJSON = error.responseJSON) == null ? void 0 : _error$responseJSON.message) || LOADING_MESSAGE_E, ERROR_HEADER, TOASTR_ERROR_OPTIONS);
        }
    }
  }
}
export const bindGlobalErrorBoundary = () => {
  window.onerror = function (message, source, lineno, columnNo, error) {
    Amplitude.logUnhandledError(error || {
      message,
      source,
      lineno,
      columnNo,
      stack: error == null ? void 0 : error.stack
    }, {
      source: "window",
      severity: "fatal",
      customData: {
        message,
        source,
        lineno,
        columnNo
      }
    });
  };
  window.onunhandledrejection = function (event) {
    Amplitude.logUnhandledError(event.reason, {
      source: "promise",
      severity: "fatal",
      customData: {
        type: "unhandledrejection"
      }
    });
  };
};